export const getTailoringMasterList = state => {
    return state.list
}

export const getTailoringMasterDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/tailoringMaster/getters.js